import gql from 'graphql-tag';
export default gql`
  mutation selectPrimaryApplicant($isCurrentUserPrimary: Boolean!, $vehicleApplicationStatus: String!, $userInfo: UserInput!) {
    selectPrimaryApplicant(
      isCurrentUserPrimary: $isCurrentUserPrimary
      vehicleApplicationStatus: $vehicleApplicationStatus
      userInfo: $userInfo
    ) {
      status
      message
      primaryApplicant {
        userId
        firstName
        lastName
        email
        phone
        confirmed
        identityVerificationStatus
      }
    }
  }
`;
